import axios from "axios";

export const getHttpResource = async (url, configs) => {
  const response = await axios.get(url, configs);
  return response;
};
